import { useMutation } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import api from '@/constant/END_POINT'

const createBackofficeApproverCondition = async (
  approvalLevelName: string,
  amountMin: number,
  amountMax: number,
) => {
  const response = await httpClientPrivate.post(api.backoffice.createBackofficeApproverCondition, {
    approvalLevelName,
    amountMin,
    amountMax,
  })

  return response.data
}

const useCreateBackofficeApproverCondition = () => {
  const mutation = useMutation({
    mutationKey: ['useCreateBackofficeApproverCondition'],
    mutationFn: async ({
      approvalLevelName,
      amountMin,
      amountMax,
    }: {
      approvalLevelName: string
      amountMin: number
      amountMax: number
    }) => createBackofficeApproverCondition(approvalLevelName, amountMin, amountMax),
  })

  return mutation
}

export { useCreateBackofficeApproverCondition }
